import React, { useState } from 'react';
import styles from './BetImageUploader.module.scss';
import classNames from 'classnames';
import SVG from 'react-inlinesvg';

/* Interfaces */
import { Mediafile } from '../interfaces/Media';

/* Translations */
import { tr } from '../../../utils/translations/translator';
import { useTranslation } from 'react-i18next';

/* Assets */
import Close from '../../../assets/icons/close.svg';
import dropdown from '../../../assets/dropdown.svg';

interface BetImageUploaderProps {
  onSelect: (betImage: Mediafile | null) => void;
  value: Mediafile | null;
  isValid: boolean;
}

export const BetImageUploader: React.FC<BetImageUploaderProps> = ({
  onSelect,
  value,
  isValid,
}) => {
  const { t } = useTranslation();
  const cx = classNames.bind(styles);
  const [betImage, setBetImage] = useState<Mediafile | null>(value);
  const [isExtended, setIsExtended] = useState<boolean>(false);

  const onBetImageUpload = (files: FileList | null) => {
    if (files === null) {
      throw new Error('Missing file to upload');
    }

    const [selectedFile] = Array.from(files);
    const file: Mediafile = {
      file: selectedFile,
      type: selectedFile.type,
      preview: URL.createObjectURL(selectedFile),
    };

    setBetImage(file);
    onSelect(file);
  };

  const onDeleteMedia = () => {
    setBetImage(null);
    onSelect(null);
    setIsExtended(false);
  };

  return (
    <div className={styles.BetImageUploader}>
      <div
        className={
          betImage
            ? cx(
                styles.uploadBox,
                styles.uploaded,
                isExtended ? styles.extended : styles.unset,
              )
            : styles.uploadBox
        }
      >
        {betImage === null ? (
          <>
            <label
              htmlFor="file-upload"
              className={
                !isValid
                  ? cx(styles.uploadBtn, styles.invalid)
                  : styles.uploadBtn
              }
            >
              {tr(t, 'upload-bet-slip')}
            </label>
            <input
              id="file-upload"
              type="file"
              onChange={({ target: { files } }) => onBetImageUpload(files)}
            />
          </>
        ) : (
          <>
            <div
              className={styles.closeContainer}
              onClick={() => {
                onDeleteMedia();
              }}
            >
              <SVG src={Close} className={styles.close} />
            </div>

            <div
              className={cx(
                styles.uploadedBetImage,
                isExtended ? styles.extended : styles.unset,
              )}
              onClick={() => setIsExtended(!isExtended)}
            >
              <img src={betImage.preview} alt="bet preview"></img>
              <label
                className={cx(
                  styles.extendLabel,
                  isExtended ? styles.hidden : styles.showing,
                )}
              >
                {tr(t, 'see-more')} <SVG src={dropdown} />
              </label>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
